import styled from 'styled-components'
import {
  tokens,
  FontIcon,
  Button as BonsaiButton
} from '@arvoreeducacao/bonsai-ds'

const { colors, fontSize, lineHeight, spacing, transitions } = tokens

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing.verticalXxsmall};
`

export const Text = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  font-style: normal;
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${fontSize.medium};
  line-height: ${lineHeight.small}%;
  width: 100%;
  max-width: 199px;
  transition: color ${transitions.default};

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;

  @media (max-width: ${tokens.breakpoints.desktop + 1}px) {
    max-width: unset;
  }
`

export const Subtitle = styled(Text)<{ color: string }>`
  font-weight: normal;
  font-size: ${fontSize.small};
  color: ${({ color }) => color};
  line-height: ${lineHeight.small}%;
  transition: color ${transitions.default};

  @media (max-width: ${tokens.breakpoints.desktop + 1}px) {
    font-size: ${fontSize.xsmall};
  }
`

export const Icon = styled(FontIcon)`
  margin-right: ${spacing.horizontalSmall};
  transition: color ${transitions.default};
`

export const Li = styled.li`
  cursor: pointer;
  list-style-type: none;
  padding: ${spacing.squishMedium};
  border-bottom: 1px solid ${colors.dark1};
  display: flex;
  flex-direction: column;
  gap: ${spacing.verticalSmall};

  @media (max-width: ${tokens.breakpoints.desktop + 1}px) {
    flex-direction: row;
    padding: ${spacing.verticalSmall} 0;
  }

  @media (max-width: ${tokens.breakpoints.tablet + 1}px) {
    align-items: center;
  }
`

export const Wrapper = styled.div`
  color: ${colors.dark5};
  font-family: Averta;
  display: flex;
  align-items: center;

  @media (max-width: ${tokens.breakpoints.desktop + 1}px) {
    flex: 1;
  }
`

export const Button = styled(BonsaiButton)`
  @media (max-width: ${tokens.breakpoints.desktop + 1}px) {
    flex: 1;
  }
`
